import { Icon } from "armstrong-react";
import { Col, Grid, Row } from "armstrong-react-fix";
import React from "react";

import { GoogleAnalyticsHelper } from "@travellocal/ui";
import "./locationImageGallery.scss";

interface Props extends React.Props<LocationImageGallery> {
  images: IAccomodationLocationImage[];
  selectedIndex?: number;
  nextClicked?: (image: IAccomodationLocationImage) => void;
  prevClicked?: (image: IAccomodationLocationImage) => void;
}

interface LocalState {
  selectedIndex: number;
}

export class LocationImageGallery extends React.Component<Props, LocalState> {
  constructor(props: Props) {
    super(props);
    this.state = { selectedIndex: 0 };
  }
  public componentWillMount() {
    this.setState({ selectedIndex: this.props.selectedIndex });
  }

  private nextImage() {
    let newIndex;
    if (this.state.selectedIndex === this.props.images.length - 1) {
      newIndex = 0;
    }
    else {
      newIndex = this.state.selectedIndex + 1;
    }
    this.setState({ selectedIndex: newIndex });
    if (this.props.nextClicked){
      this.props.nextClicked(this.props.images[newIndex]);
    }
    GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Next Image");
  }

  private prevImage() {
    let newIndex;
    if (this.state.selectedIndex > 0) {
      newIndex = this.state.selectedIndex - 1;
    }
    else {
      newIndex = this.props.images.length - 1;
    }
    this.setState({ selectedIndex: newIndex });
    if (this.props.prevClicked){
      this.props.prevClicked(this.props.images[newIndex]);
    }
    GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Previous Image");
  }

  public render() {
    const currentImage = this.props.images[this.state.selectedIndex];
    if (!currentImage) {
      return null;
    }
    return (
      <Grid fillContainer={true} className="image-grid">
        <Row className="rs-medium-1col rs-medium-spaced">
          <Col className={`image-cell${currentImage.description ? "" : " no-text"}`}>
            <p className="text--label text--mid">{this.state.selectedIndex + 1} of {this.props.images.length}</p>
            <Grid>
              <Row>
                <Col className="relative">
                  <div className="prev-image-col" onClick={() => this.prevImage() }>
                    <Icon icon={Icon.Icomoon.arrowLeft3}/>
                  </div>
                  <div className="location-image-content" style={{ backgroundImage: `url('${currentImage.largeUrl}')` }}/>
                  <div className="next-image-col" onClick={() => this.nextImage() }>
                    <Icon icon={Icon.Icomoon.arrowRight3}/>
                  </div>
                </Col>
              </Row>
            </Grid>
          </Col>
          {currentImage.description &&
            <Col width={425} className="text-cell p-left-medium rs-medium-unfix" >
            <p>{currentImage.description}</p>
          </Col>
          }
        </Row>
      </Grid>
    );
  }
}
